import Vue from "vue";
import App from "./components/App.vue";
import store from "./store"
import router from "./router";
import vuetify from "./plugins/vuetify";
import "./sass/variables.scss";
import "vuetify/dist/vuetify.min.css";
import Vuelidate from "vuelidate";
import Paginate from 'vuejs-paginate'
import snackbarPlugin from './plugins/snackbar'

Vue.use(snackbarPlugin, { store })
Vue.use(Vuelidate);
Vue.component('paginate', Paginate)
Vue.config.productionTip = false;

export const vm = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount("#app");